import RteWithImageBlock from './RteWithImageBlock';

export default RteWithImageBlock;
